import React, { Component } from 'react';
import Table5_9_1 from "./5-9-1";
import Table5_9_2 from "./5-9-2";
import Table5_9_3 from "./5-9-3";

import "./index.scss";

export class index extends Component {
    render() {
        return (
            <div className="tb5_8 tb5_9">
                <div className="tb5_8-title">
                    5.9 美团点评套餐销量统计 Meituan Dianping Package Sales Summary
                </div>

                <Table5_9_1 {...this.props} />
                <Table5_9_2 {...this.props} />
                <Table5_9_3 {...this.props} />
            </div>
        )
    }
};

export default index;



// WEBPACK FOOTER //
// ./src/components/table/5.0/5-9/index.js